// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var NotificationsCounterChangedEvent;
(function (NotificationsCounterChangedEvent) {
    NotificationsCounterChangedEvent[NotificationsCounterChangedEvent["NewArr"] = 0] = "NewArr";
    NotificationsCounterChangedEvent[NotificationsCounterChangedEvent["AddOne"] = 1] = "AddOne";
    NotificationsCounterChangedEvent[NotificationsCounterChangedEvent["RemoveOne"] = 2] = "RemoveOne";
})(NotificationsCounterChangedEvent || (NotificationsCounterChangedEvent = {}));
